// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_2yG","importantInfo":"styles_importantInfo__2UIKa"};